import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const ENVIRONMENT_NAME = import.meta.env.VITE_ENVIRONMENT_NAME ?? "local"
const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: !!SENTRY_DSN,
  environment: ENVIRONMENT_NAME,
  release: SENTRY_RELEASE,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  tracesSampleRate: 1.0,
  denyUrls: [/embed\.tawk\.to/, /tawk\.to/],
  // Transport-layer fetch failures (flaky mobile networks, backgrounded tabs) — not actionable as bugs.
  ignoreErrors: [
    "Failed to fetch", // Chromium / Edge
    "Load failed", // Safari / iOS
    "NetworkError when attempting to fetch resource", // Firefox
    // In-app WebView autofill agents inject an `execute_auto_fill` script that
    // references an undefined `xbrowser` global; the throw surfaces via window.onerror
    // as if it were ours. Not our code — drop it.
    "xbrowser is not defined",
  ],
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:/ / yourserver.io / api / ],
})
